import React, { ChangeEvent } from "react";
import { Input } from "antd";
import ZTooltip from "@atoms/ZTooltip";
import { ZIcon, ZTypography } from "@atoms";
import { EIcons } from "@atoms/ZIcon/interface";
import { EColors } from "@atoms/ZColors/interface";

interface PricingFieldProps {
	label: string;
	value: string;
	error?: string;
	placeholder?: string;
	showPercentAddon?: boolean;
	onChange: (e: ChangeEvent<HTMLInputElement>) => void;
	readOnly?: boolean;
	onFocus?: () => void;
	tooltip?: string;
}

const PricingField: React.FC<PricingFieldProps> = ({
	label,
	value,
	error,
	placeholder,
	showPercentAddon = false,
	onChange,
	readOnly = false,
	onFocus,
	tooltip
}) => {
	const percentAddon = showPercentAddon ? (
		<div
			className="w-8 h-7 bg-gray-4 flex items-center justify-center"
			style={{ transform: "scaleX(-1)" }}
		>
			<ZTypography.ZText color={EColors.GRAY} colorVariant={6}>
				%
			</ZTypography.ZText>
		</div>
	) : undefined;

	return (
		<div
			className={`flex items-center gap-3 mb-6 ${
				readOnly ? "opacity-50 cursor-pointer" : ""
			}`}
			onClick={readOnly ? onFocus : undefined}
		>
			<div className="flex items-center gap-1 flex-shrink-0">
				<ZTypography.ZText
					color={EColors.GRAY}
					colorVariant={9}
					className="font-medium text-1"
				>
					{label}
				</ZTypography.ZText>

				{tooltip && (
					<ZTooltip title={tooltip}>
						<span className="flex items-center">
							<ZIcon
								name={EIcons.INFOCIRCLE}
								size="sm"
								color={EColors.GRAY}
								colorVariant={6}
							/>
						</span>
					</ZTooltip>
				)}
			</div>

			<div className="flex flex-col flex-1">
				<div className={`w-full ${error ? "error-input" : ""}`}>
					<Input
						type="number"
						placeholder={placeholder}
						value={value}
						onChange={readOnly ? undefined : onChange}
						onFocus={readOnly ? onFocus : undefined}
						addonAfter={percentAddon}
						readOnly={readOnly}
						className={`h-8 text-1 ${error ? "border-red-5" : ""} ${
							readOnly ? "bg-gray-2 cursor-pointer" : ""
						}`}
					/>
				</div>

				{error && (
					<ZTypography.ZText
						color={EColors.RED}
						colorVariant={6}
						className="text-xs mt-1"
					>
						{error}
					</ZTypography.ZText>
				)}
			</div>
		</div>
	);
};

export default PricingField;
